import { useCallback } from "react";
import { useIntl } from "react-intl";

export function useTranslations(namespace: string) {
  const intl = useIntl();

  return useCallback(
    (key: string, values?: Record<string, string | number>) =>
      intl.formatMessage({ id: `${namespace}.${key}` }, values),
    [intl, namespace],
  );
}
